import colors from '@bnnvara/themes';
import PropTypes from 'prop-types';
import React from 'react';

const Check = ({
  color
}) => /*#__PURE__*/React.createElement("svg", {
  width: "18px",
  height: "16px",
  viewBox: "0 0 18 16",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-label": "check wachtwoord validatie icoon"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-19.000000, -347.000000)",
  fill: color,
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path-2",
  points: "33.7286436 347.585786 36.5570707 350.414214 24.8571429 362.114141 19.5857864 356.842785 22.4142136 354.014358 24.8571429 356.457287"
}))));

Check.propTypes = {
  color: PropTypes.string
};
Check.defaultProps = {
  color: colors.bnnvara.base.white
};
export default Check;